/**
 * Config: Tygporaphy
 * -----------------------------------------------------------------------------
 * CSS class map for typography text line styles.
 * See typography.liquid for Liquid counterpart
 *
 */

export const textStyles = {
  'Heading - 2XL': 'text-heading-m',
  'Heading - XL': 'text-heading-s',
  'Heading - L': 'text-heading-xs',
  'Heading - M': 'text-body-l-medium',
  'Body - L': 'text-body-l-regular',
  'Body - M': 'text-body-m-regular',
  'Body - S': 'text-body-s-regular',
}
